import { Files, FilesStatus } from '@flatsy/types/Files'
import { Applicant, RequiredUploadSubFiles } from '@flatsy/types/Applications'
import {
  ArrayForProgressionKind,
  ArrayForProgressionMainKind,
  CreateArrayForProgressionProps,
  ProgressionResult,
} from './Type'

export const createArrayForProgression = ({
  required_upload,
  files,
}: CreateArrayForProgressionProps): ArrayForProgressionMainKind[] => {
  const mainKindArray: ArrayForProgressionMainKind[] = []
  if (required_upload && files) {
    /* --------------------------- LOOP OVER MAIN KIND -------------------------- */
    required_upload.forEach((required) => {
      /* ------------------------- CREATE BASE KIND OBJECT ------------------------ */
      const mainKind: ArrayForProgressionMainKind = {
        kind: required.kind,
        valid: false,
        min: 0,
        count: 0,
        child: [],
      }
      /* ----------------------------- LOOP OVER CHILD KIND  ---------------------------- */
      required.required.forEach((childRequired: RequiredUploadSubFiles) => {
        /* ------------------------- CREAT BASE CHILD OBJECT ------------------------ */
        const subKind: ArrayForProgressionKind = {
          kind: childRequired.kind,
          min: childRequired.min,
          valid: false,
          file: [],
        }
        /* -------------------- CHECK IF A FILE EXIST FOR A KIND -------------------- */
        const hasFile = files.filter(
          (file) => file.kind === childRequired.kind && file.status === FilesStatus.VALIDATED
        )
        if (hasFile && hasFile.length > 0) {
          hasFile.forEach((singleFile) => {
            subKind.file.push(singleFile)
          })
          if (subKind.file.length >= subKind.min) {
            /* -------------------- IF LENGTH IS EQUAL TO MINIUM FILE SET VALID TRUE ------------------- */
            mainKind.count = subKind.min
            mainKind.min = subKind.min
            subKind.valid = true
          } else {
            mainKind.count = subKind.file.length
            mainKind.min = subKind.min
          }
        } else if (
          mainKind.min === 0 ||
          (mainKind.min !== mainKind.count && mainKind.min < subKind.min)
        ) {
          /* -------------------- IF MIN IS ZERO OR MIN > CHILD MIN ------------------- */
          mainKind.count = 0
          mainKind.min = subKind.min
        }
        mainKind.child.push(subKind)
      })
      /* ----------------------- IF ONE CHILD KIND IS VALID ----------------------- */
      if (mainKind.child.find((el) => el.valid === true)) {
        mainKind.valid = true
      }
      mainKindArray.push(mainKind)
    })
  }
  return mainKindArray
}

export const getProgressionForApplicant = ({
  required_upload,
  files,
}: CreateArrayForProgressionProps): ProgressionResult => {
  const array = createArrayForProgression({ required_upload, files })
  const count = {
    uploaded: 0,
    needed: 0,
    percent: '0',
    complete: false,
  }

  array.forEach((single) => {
    count.uploaded += single.count
    count.needed += single.min
  })
  if (count.uploaded >= count.needed) {
    count.percent = '100'
    count.complete = true
  } else {
    count.percent = `${Math.round((count.uploaded / count.needed) * 100)}`
  }
  return count
}

export const getProgressionForApplication = ({
  applicants,
  files,
}: {
  applicants: Applicant[] | undefined
  files: Files[]
}): ProgressionResult => {
  const count = {
    uploaded: 0,
    needed: 0,
    percent: '0',
    complete: false,
  }
  if (applicants && files) {
    applicants.forEach((applicant) => {
      const applicantFiles = files.filter((file) => file.applicant === applicant.id)
      const applicantCount = getProgressionForApplicant({
        required_upload: applicant.required_uploads,
        files: applicantFiles,
      })
      count.needed += applicantCount.needed
      count.uploaded += applicantCount.uploaded
    })
    if (count.uploaded >= count.needed) {
      count.percent = '100'
      count.complete = true
    } else {
      count.percent = `${Math.round((count.uploaded / count.needed) * 100)}`
    }
  }
  return count
}
